import { render } from "./LanguageSelectDropdown.vue?vue&type=template&id=c4ebda7e&scoped=true"
import script from "./LanguageSelectDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageSelectDropdown.vue?vue&type=script&lang=js"

import "./LanguageSelectDropdown.vue?vue&type=style&index=0&id=c4ebda7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ebda7e"]])

export default __exports__